import * as React from 'react';
import { ReactElement } from 'react';
import { connect } from 'react-redux';
import { Element } from 'react-scroll';
import { ClientShortHandName, mainHostnameFromHostname } from '@snoam/mono-scc';
import '../../webfont/logo/icons.css';
import { getIdentity } from '../actions/Actions';
import * as CustomTypes from '../CustomTypes';
import { createStartPageFullUrl } from '../fastflowUtils';
import {
  svgAgder24Logo,
  svgAvAvisLogo,
  svgBergensTidendeLogo,
  svgBsnettLogo,
  svgBygdanyttLogo,
  svgE24dinepengerLogo,
  svgKvinesdal24Logo,
  svgLindesnesLogo,
  svgLister24Logo,
  svgSaLogo,
  svgStrilenLogo,
  svgSyslaLogo,
  svgVestnyttLogo
} from '../icons';
import './Header.scss';

export interface IHeaderProps {
  productInfo: CustomTypes.IProductInfo;
  referer: CustomTypes.IReferer;
  sessionInfo: CustomTypes.ISessionInfo;
  domain: string;
}
export class Header extends React.Component<IHeaderProps, {}> {
  constructor(props: IHeaderProps) {
    super(props);
    this.logout = this.logout.bind(this);
  }

  public render() {
    const { owningClient } = this.props.productInfo;
    const clientLowerCased = owningClient.toLowerCase();
    const { givenName } = this.props.sessionInfo;
    const { domain } = this.props;
    const svgLogo: {
      [k: string]: (
        height: number | string,
        width: number | string
      ) => ReactElement<any>;
    } = {
      AGR: svgAgder24Logo,
      ASB: svgBsnettLogo,
      ASK: svgAvAvisLogo,
      BTI: svgBergensTidendeLogo,
      BYN: svgBygdanyttLogo,
      DP: svgE24dinepengerLogo,
      FAK: svgLister24Logo,
      KVN: svgKvinesdal24Logo,
      LIN: svgLindesnesLogo,
      SA: svgSaLogo,
      STR: svgStrilenLogo,
      SYS: svgSyslaLogo,
      VNY: svgVestnyttLogo
    };
    return (
      <div className={`header header-${clientLowerCased} site-header`}>
        <div className="header-outer">
          <div className="header-inner">
            <Element name="scrollToStartElement" />

            {givenName && (
              <span className="btn-group">
                <button
                  className="dropdown-toggle menu-toggle"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="icon ion-navicon-round" />
                  &nbsp;
                </button>
                <ul className="dropdown-menu pull-right">
                  <li className="">
                    <a onClick={this.logout}>Logg ut</a>
                  </li>
                </ul>
              </span>
            )}

            <span className="username">{givenName}</span>
            <a
              className={`icon-${clientLowerCased} logo ${
                svgLogo[owningClient] ? 'icon-hide' : ''
              }`}
              href={`//${domain}`}
              tabIndex={-1}
            >
              {svgLogo[owningClient] ? svgLogo[owningClient](42, '100%') : null}
            </a>
          </div>
        </div>
      </div>
    );
  }

  private logout() {
    const { owningClient, productId } = this.props.productInfo;
    const startPageFullUrl = createStartPageFullUrl(productId);
    getIdentity(owningClient as ClientShortHandName).logout(startPageFullUrl);
  }
}

export default connect(state => ({
  domain: mainHostnameFromHostname(window.location.hostname),
  productInfo: state.productInfo,
  referer: state.referer,
  sessionInfo: state.sessionInfo
}))(Header);



// WEBPACK FOOTER //
// ./src/layout-components/Header.tsx